export const FETCH_NOTE_SHEET_DETAILS = 'pages/workflow/notesheet/FETCH_NOTE_SHEET_DETAILS';
export const FETCH_NOTE_SHEET_COMMENTS = 'pages/workflow/notesheet/FETCH_NOTE_SHEET_COMMENTS';
